import {mergeDeep} from '@sollapay/utils';

import {createEmptyBuyerFormEntry} from '@/features/buyers/validation';

import type {BuyerEntryFormValues} from '@/features/buyers/validation';

// Uses mergeDeep's in-place mutation, not its return value — MergeDeep<T, U> mistypes array fields like pep.parties.
export function mergeBuyerWithDefaults(
  buyer: Partial<BuyerEntryFormValues> | undefined
): BuyerEntryFormValues {
  const merged = createEmptyBuyerFormEntry();
  if (buyer) mergeDeep(merged, buyer);
  return merged;
}
